/**
 * 配置文件
 */

const config = {
    debug: false,
    /**
     * 所有支持的接口集合
     */
    api: {
        initEntrance: {
            fn: 'initEntrance',
            alias: 'init_entrance'
        },

        invokeEntrance: {
            fn: 'invokeEntrance',
            alias: 'invoke_entrance'
        },

        showEntrance: {
            fn: 'showEntrance',
            alias: 'show_entrance'
        },

        hideEntrance: {
            fn: 'hideEntrance',
            alias: 'hide_entrance'
        },

        shareWeixinTimeline: {
            fn: 'shareWeixinTimeline',
            alias: 'share_weixin_timeline'
        },

        shareWeixinAppmsg: {
            fn: 'shareWeixinAppmsg',
            alias: 'share_weixin_appmsg'
        },

        shareAlipayLife: {
            fn: 'shareAlipayLife'
        },

        shareAlipayFriend: {
            fn: 'shareAlipayFriend'
        },

        shareQzone: {
            fn: 'shareQzone',
            alias: 'share_qzone'
        },

        shareQqAppmsg: {
            fn: 'shareQqAppmsg',
            alias: 'share_qq_appmsg'
        },

        shareSinaWeibo: {
            fn: 'shareSinaWeibo',
            alias: 'share_sina_weibo'
        },
        shareFacebook: {
            fn: 'shareFacebook'
        },
        shareLine: {
            fn: 'shareLine'
        },
        shareWhatsApp: {
            fn: 'shareWhatsApp'
        },
        shareTwitter: {
            fn: 'shareTwitter'
        },
        shareEmail: {
            fn: 'shareEmail'
        },
        shareSMS: {
            fn: 'shareSMS'
        },

        getUserInfo: {
            fn: 'getUserInfo'
        },

        getSystemInfo: {
            fn: 'getSystemInfo'
        },

        getLocationInfo: {
            fn: 'getLocationInfo'
        },

        apolloGetToggle: {
            fn: 'apolloGetToggle'
        },

        refreshPage: {
            fn: 'refreshPage',
            alias: 'page_refresh'
        },

        closePage: {
            fn: 'closePage',
            alias: 'page_close'
        },

        openPage: {
            fn: 'openPage',
            alias: 'open_url'
        },
        clearCache: {
            fn: 'clearCache',
            support: '5.0.10'
        },
        launchScan: {
            fn: 'launchScan',
            support: '5.0.20'
        },
        requestLogin: {
            fn: 'requestLogin',
            alias: 'callNativeLogin',
            support: '5.0.10'
        },
        setTitle: {
            fn: 'setTitle',
            alias: 'updateNaviTitle',
            paramsAlias: 'navi_title'
        },
        photograph: {
            fn: 'photograph',
            support: '5.0.12'
        },
        commonPay: {
            fn: 'commonPay',
            alias: ['payByWX', 'payByAli'],
            support: '5.0.10'
        },
        launchNav: {
          fn: 'launchNav',
        },
        scanQRCode: {
          fn: 'scanQRCode',
        },
    }
};

export default config;



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/config.js